// extracted by mini-css-extract-plugin
export var alertIcon = "_mu-0";